import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/** Format an ISO string or Date with the runtime locale's short date style. */
export function formatDisplayDate(date: string | Date): string {
  return new Date(date).toLocaleDateString();
}
